$ = jQuery;
import { hideQuickSearch } from "./quickSearch";

const CSS_MENU_ITEM_OPENED = "MobileMenu__menuItem--opened";
const CSS_HEADER_MENU_OPENING = "MobileHeader--menuOpening";
const CSS_HEADER_MENU_OPENED = "MobileHeader--menuOpened";
const CSS_SITE_MENU_OPENED = "Site--mobileMenuOpened";

function closeMenu() {
  const $header = $(".js-mobileheader");
  const $opener = $(".js-mobilemenu-opener");
  const $site = $(".js-site");

  $site.removeClass(CSS_SITE_MENU_OPENED);
  $header.removeClass(CSS_HEADER_MENU_OPENED);

  window.setTimeout(() => {
    $header.removeClass(CSS_HEADER_MENU_OPENING);
    $(`.${CSS_MENU_ITEM_OPENED}`).removeClass(CSS_MENU_ITEM_OPENED);
  }, 500);
}

function setupMenuOpening() {
  const $header = $(".js-mobileheader");
  const $opener = $(".js-mobilemenu-opener");
  const $closer = $(".js-mobilemenu-closer");
  const $site = $(".js-site");

  $opener.click(function() {
    hideQuickSearch();
    $site.addClass(CSS_SITE_MENU_OPENED);
    window.requestAnimationFrame(() => {
      $header.addClass(CSS_HEADER_MENU_OPENING);
      window.requestAnimationFrame(() => {
        $header.addClass(CSS_HEADER_MENU_OPENED);
      });
    });
  });

  $closer.click(closeMenu);
}

function setupSubMenuItems() {
  $(".js-mobilemenu-parent > a").click(function(event) {
    event.preventDefault();
    const $parent = $(this).closest(".js-mobilemenu-parent");
    $parent.addClass(CSS_MENU_ITEM_OPENED);
  });

  $(".js-mobilemenu-back").click(function() {
    const $parent = $(this).closest(".js-mobilemenu-parent");
    $parent.removeClass(CSS_MENU_ITEM_OPENED);
  });
}

function setupMenu() {
  setupSubMenuItems();
  setupMenuOpening();
}

export default function() {
  $(setupMenu);
}
